import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { Fragment } from '../fragment'
import { Props } from '../types'

export const mount: MountWithRootOptions<Props> = async (rootElement, renderProps, rootOptions) => {
  return clientMount(<Fragment {...renderProps} />, rootElement, rootOptions)
}
